import Service, { getCallApiFunction } from '../service'
import { helpCountryHeader } from '../fetchHelpArticle'
import type { FetchHelpArticleResponse } from '../fetchHelpArticle'

/**
 * 固定頁面代號（shop-api service/helpcenter/page_alias.go）。
 * 條款三份在後台「條款與政策」維護；其餘在 FAQ 文章 / 分類的「網站固定連結」指定。
 */
export const HELP_PAGE_KEY = {
  USER_TERMS: 'user-terms',
  PRIVACY_POLICY: 'privacy-policy',
  LEGAL_DISCLAIMER: 'legal-disclaimer',
  RETURN_POLICY: 'return-policy',
  CVS_RETURN_INSTRUCTIONS: 'cvs-return-instructions',
  CUSTOMER_SERVICE: 'customer-service',
} as const

export interface IParams {
  pageKey: string
  countryCode: string
}

export interface FetchHelpPageResponse {
  pageKey: string
  type: 'article' | 'collection'
  id: number
  slug: string
  /** type = article 時才有 */
  article?: FetchHelpArticleResponse
}

// 幫助中心固定頁面（條款、退貨政策等）
class FetchHelpPageApi extends Service {
  constructor({ pageKey, countryCode }: IParams) {
    super()
    this.name = 'FETCH_HELP_PAGE'

    this.config = {
      url: `/v1/help/pages/${encodeURIComponent(pageKey)}`,
      method: 'GET',
      headers: helpCountryHeader(countryCode),
    }
  }
}

export const fetchHelpPage = (params: IParams): Promise<FetchHelpPageResponse> => getCallApiFunction(new FetchHelpPageApi(params))
